export const qpNameForOriginCheck = 'origin';
export const qpOriginExpectedForRedirectFromVerizon =
  'digitalready-verizonwireless';
export const qpNameForCodeCheck = 'code';
export const qpCodeExpected = process.env.REACT_APP_VERIZON_REDIRECT_CHECK_CODE;
export const cookieNameForRedirectsFromVerizon =
  'redirect-from-verizon-confirmed';
export const cookieMaxAgeForRedirectsFromVerizon = 1000 * 60 * 60 * 24 * 30; // 30 days
